import { render, staticRenderFns } from "./FormFormattedInputElement.vue?vue&type=template&id=7f159006&scoped=true"
import script from "./FormFormattedInputElement.vue?vue&type=script&lang=js"
export * from "./FormFormattedInputElement.vue?vue&type=script&lang=js"
import style0 from "./FormFormattedInputElement.vue?vue&type=style&index=0&id=7f159006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f159006",
  null
  
)

export default component.exports